// @flow
import * as React from "react";
import { Icon } from "semantic-ui-react";
import { Trans } from "react-i18next";

import Styles from "./SuccessfullySaved.module.scss";

const SuccessfullySaved = ({ children }: { children: React.ReactNode }) => (
  <div className={Styles.success}>
    <div>{children}</div>
    <div className={Styles.successSign}>
      <Icon name="check circle outline" size="large" color="green" className="check" />
      <div className={Styles.successfullySavedText}>
        <Trans i18nKey="missingData:successfullySaved">
          <br />
        </Trans>
      </div>
    </div>
  </div>
);

export default SuccessfullySaved;
